/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';

function CustomToast({
    open, message, setopen, color,
}) {
    return (

        <Modal open={open} onClose={() => setopen(false)} showCloseIcon={false} style={{PointerEvent:'none'}} classNames={{ modal: 'alert-toast-modal' }} styles={{ modal: { background: 'transparent', boxShadow: 'none', padding: 0, maxWidth: '450px', width: '450px' } }}>
            <div className={`flex items-start border-l-8 border-[${color || '#309A5D'}] bg-[#FFFFFF] rounded-[7px] shadow-s2 w-[450px]`} role="alert">
                {message}
            </div>
        </Modal>

    );
}

export default CustomToast;
